"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
var react_1 = __importStar(require("react"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var Box_1 = require("./Box");
var Grid_1 = require("./Grid");
var useLayoutStyles = (0, system_1.makeStyles)(function (theme) { return (__assign(__assign({}, theme.go.mixins.typography.fontFaces), { layout: __assign({ backgroundColor: theme.go.schemes.colors.system.BgMain, width: '100%', minWidth: function (_a) {
            var gridType = _a.gridType;
            return theme.go.schemes.spacing[gridType].minContentWidth;
        }, '& *': {
            boxSizing: 'border-box',
        } }, theme.go.mixins.typography.Body), gridWrapper: function (_a) {
        var gridType = _a.gridType, bordered = _a.bordered;
        return (__assign({ maxWidth: theme.go.schemes.spacing[gridType].maxContentWidth, minWidth: theme.go.schemes.spacing[gridType].minContentWidth, paddingLeft: theme.go.schemes.spacing[gridType].spaceUnit, 
            // paddingRight: theme.go.schemes.spacing[gridType].spaceUnit,
            width: '100%', position: 'relative' }, (bordered
            ? {
                outline: "1px solid ".concat(theme.go.schemes.colors.system.Divider),
            }
            : {})));
    } })); });
function Layout(_a) {
    var gridType = _a.gridType, children = _a.children, debug = _a.debug, classes = _a.classes, bordered = _a.bordered, pb = _a.pb, pt = _a.pt, gridProps = __rest(_a, ["gridType", "children", "debug", "classes", "bordered", "pb", "pt"]);
    var _b = useLayoutStyles({ gridType: gridType, bordered: bordered }), layout = _b.layout, gridWrapper = _b.gridWrapper;
    var theme = (0, system_1.useTheme)();
    var columns = theme.go.schemes.spacing[gridType].columns;
    var context = (0, react_1.useMemo)(function () { return ({
        type: gridType,
        k: 1,
        parentColumns: columns,
    }); }, [columns, gridType]);
    return (react_1.default.createElement(Grid_1.GridContext.Provider, { value: context },
        react_1.default.createElement(Box_1.Box, { className: (0, utils_1.cn)(layout, classes === null || classes === void 0 ? void 0 : classes.layout), flexGrow: 1, justifyContent: "center" },
            react_1.default.createElement(Box_1.Box, { className: (0, utils_1.cn)(gridWrapper, classes === null || classes === void 0 ? void 0 : classes.gridWrapper), pb: pb, pt: pt },
                debug && react_1.default.createElement(Grid_1.GridHelper, null),
                react_1.default.createElement(Grid_1.Grid, __assign({}, gridProps, { columns: columns, container: true }), children)))));
}
exports.Layout = Layout;
